import { render, staticRenderFns } from "./RecoveryNewPassPage.vue?vue&type=template&id=110b8c04&"
import script from "./RecoveryNewPassPage.vue?vue&type=script&lang=js&"
export * from "./RecoveryNewPassPage.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryNewPassPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports